// Zet de klantenservice-link op "online" binnen de openingstijden (Europe/Amsterdam).
// Openingstijden komen uit data-attributen op de link zelf.
(function () {
  var link = document.querySelector('[data-klantenservice-status]');
  if (!link) return;

  var DEFAULT_OPEN_TIME = '09:00';
  var DEFAULT_CLOSE_TIME = '13:00';
  var DEFAULT_OPEN_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

  function parseTimeToMinutes(value, fallback) {
    var time = (value || '').trim() || fallback;
    var match = /^(\d{1,2}):(\d{2})$/.exec(time);
    if (!match) return parseTimeToMinutes(fallback, fallback);

    var hours = parseInt(match[1], 10);
    var minutes = parseInt(match[2], 10);
    if (hours > 23 || minutes > 59) return parseTimeToMinutes(fallback, fallback);

    return hours * 60 + minutes;
  }

  function getOpenDays() {
    var raw = (link.getAttribute('data-open-days') || '').trim();
    if (!raw) return DEFAULT_OPEN_DAYS.slice();

    var days = raw
      .split(',')
      .map(function (day) {
        return day.trim();
      })
      .filter(Boolean);

    return days.length ? days : DEFAULT_OPEN_DAYS.slice();
  }

  function getNowInAmsterdam() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Amsterdam',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    }).formatToParts(new Date());

    var weekday = '';
    var hour = 0;
    var minute = 0;

    parts.forEach(function (part) {
      if (part.type === 'weekday') weekday = part.value;
      if (part.type === 'hour') hour = parseInt(part.value, 10) % 24;
      if (part.type === 'minute') minute = parseInt(part.value, 10);
    });

    return {
      weekday: weekday,
      minutes: hour * 60 + minute,
    };
  }

  function isOnline() {
    var now = getNowInAmsterdam();
    var openDays = getOpenDays();
    if (openDays.indexOf(now.weekday) === -1) return false;

    var openMinutes = parseTimeToMinutes(link.getAttribute('data-open-time'), DEFAULT_OPEN_TIME);
    var closeMinutes = parseTimeToMinutes(link.getAttribute('data-close-time'), DEFAULT_CLOSE_TIME);

    return now.minutes >= openMinutes && now.minutes < closeMinutes;
  }

  function update() {
    link.classList.toggle('is-online', isOnline());
  }

  update();
  setInterval(update, 60 * 1000);
})();
